import { GridSize } from '@mui/material'
import { DetailInfo, DetailRow } from '@labrav/common'
import { useStyles } from './OfferMarkup.styles'

export type TcvColumn = {
  header: string
  value: string
  isPrice?: boolean
}

export const TotalComponent = ({
  columns,
  currencySymbol,
}: {
  columns: TcvColumn[]
  currencySymbol?: string
}) => {
  const { classes } = useStyles()
  return (
    <DetailRow className={classes.tcv}>
      <>
        {columns?.map(columnItem => (
          <DetailInfo
            gridSize={(12 / columns?.length) as GridSize}
            title={columnItem?.header}
            value={
              <div className={classes.price}>
                {columnItem?.isPrice && (
                  <span className={classes.currency} data-testid={'currency'}>
                    {currencySymbol}
                  </span>
                )}
                <span>{columnItem?.value}</span>
              </div>
            }
          />
        ))}
      </>
    </DetailRow>
  )
}
